const formatCurrency = (amount) =>
  new Intl.NumberFormat("mm-MM").format(amount);

export default formatCurrency;
